import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { DestroySubscribers, ISubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { ListSettingsModel } from './list-settings-model';

@Component({
  templateUrl: './list-settings.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ListSettingsComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ListSettingsComponent),
      multi: true,
    },
  ],
})
@DestroySubscribers()
export class ListSettingsComponent implements ControlValueAccessor, Validator {
  constructor(private cd: ChangeDetectorRef) {}
  /**
   * p500-ui-control-dynamic-component not working with FormArray :(
   */
  public form: FormGroup<Record<string, AbstractControl>> = new FormGroup({});
  public subscribers: ISubscribers = {};
  public list = new Map<string, ListSettingsModel>();
  public itemsList = new Map<string, ListSettingsModel>();
  public title: string;
  @Input() set config(item: {
    title: string;
    list: ListSettingsModel[];
    writeValueTransformer: (value: any) => { key: string; value: unknown }[];
    changeValueTransformer?: (value: Record<string, any>) => any;
  }) {
    this.itemsList.clear();
    this.list.clear();
    this.subscribers.form?.unsubscribe();
    this.title = item.title;
    this.form = new FormGroup({});
    for (const value of item.list) {
      this.list.set(value.key, value);
    }
    this.writeValueTransformer = item.writeValueTransformer;
    const transformer = item.changeValueTransformer || ((v) => v);
    this.subscribers.form = this.form.valueChanges.subscribe((items) => {
      this.onChange(transformer(items));
      this.onTouch();
    });
    for (const settings of item.list) {
      if (settings.default) {
        this.add(settings.key);
      }
    }
  }
  private writeValueTransformer: (value: any) => any;
  private onChange: (value: any) => void = () => {};
  private onTouch: () => void = () => {};

  public add(key: string, value = null): void {
    try {
      const item = this.list.get(key);
      if (value !== null) {
        item.formControl.setValue(value);
      }
      this.itemsList.set(key, item);
      this.form.addControl(key, item.formControl);
    } catch {}
  }

  public remove(key: string): void {
    this.itemsList.delete(key);
    this.form.removeControl(key);
  }

  public writeValue(obj: any): void {
    for (const { key, value } of this.writeValueTransformer(obj)) {
      this.add(key, value);
    }
    this.cd.detectChanges();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public validate(): ValidationErrors | null {
    return this.form.invalid ? { errors: true } : null;
  }
}
